import { render, staticRenderFns } from "./source_material_sidebar.vue?vue&type=template&id=0f2e11b5&scoped=true&"
import script from "./source_material_sidebar.vue?vue&type=script&lang=js&"
export * from "./source_material_sidebar.vue?vue&type=script&lang=js&"
import style0 from "./source_material_sidebar.vue?vue&type=style&index=0&id=0f2e11b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2e11b5",
  null
  
)

export default component.exports